export default __webpack_public_path__ + "713bd9a7761e333a7e95af798faa5bca.svg";